import { ReactElement } from "react";
import { IIndicatorGroupResult } from "../../../../../services/http/indicatorlist/models/IIndicatorGroupResult";
import IndicatorItem from "../IndicatorItem";
import styles from "./IndicatorGroup.module.scss";

interface IIndicatorGroupProps
{
    group: IIndicatorGroupResult;
    componentId: number;
    widgetId: number;
    statusHistoryId: number | undefined;
}

function IndicatorGroup(props: IIndicatorGroupProps): ReactElement
{
    const { group } = props;

    return (
        <div className={styles.indicatorGroupWrapper}>
            <div className={styles.heading}>
                <h4>{group.typeName}</h4>
            </div>

            <div className={styles.mainBox}>
                {group.indicators
                    .filter(x => !x.isAori)
                    .map(x => (
                        <IndicatorItem
                            key={x.indicatorId}
                            indicator={x}
                            componentId={props.componentId}
                            widgetId={props.widgetId}
                            statusHistoryId={props.statusHistoryId}
                            componentName={group.typeName}
                        />
                    ))}
            </div>
        </div>
    );
}

export default IndicatorGroup;